import App from 'app/app.js';
import 'app/store/ContentStore.js';

function LtTranslateFilter(ContentStore) {
  return function (code, messageParameters) {
    var message = ContentStore.getContent(null, code);

    if (messageParameters) {
      R.forEach(function (propName) {
        message = message.replace('{{' + propName + '}}', messageParameters[propName]);
      }, Object.getOwnPropertyNames(messageParameters));
    }
    return message;
  };
}

App.filter('ltTranslateFilter', ['ContentStore', LtTranslateFilter]);
